import React from 'react';
import PropTypes from 'prop-types';
import ProfileDragWrapper from '../ProfileDragWrapper';

const ProfileWrapper = ({ ...props }) => <ProfileDragWrapper {...props} />;

const ProfileList = ({
  profiles,
  selectedProfileId,
  onProfileClick,
  onDropProfile,
  profileLimit,
}) =>
  profiles.map((profile, index) => (
    <ProfileWrapper
      avatarUrl={profile.avatarUrl}
      type={profile.type}
      handle={profile.handle}
      pendingCount={profile.pendingCount}
      sentCount={profile.sentCount}
      selected={profile.id === selectedProfileId}
      locked={profile.disabled}
      disconnected={profile.isDisconnected}
      onClick={() => onProfileClick(profile)}
      profileLimit={profileLimit}
      onDropProfile={onDropProfile}
      organizationId={profile.organizationId}
      id={profile.id}
      index={index}
      key={profile.id}
      location={profile.location}
      additionalInfo={profile.locationData ?? profile.serverUrl}
    />
  ));

ProfileList.propTypes = {
  onProfileClick: PropTypes.func.isRequired,
  onDropProfile: PropTypes.func.isRequired,
  selectedProfileId: PropTypes.string,
  profileLimit: PropTypes.number.isRequired,
};

ProfileList.defaultProps = {
  profiles: [],
  selectedProfileId: undefined,
};

export default ProfileList;
